import { lazy } from "react";
import { RouteObject } from "react-router-dom";

// Passport
const PassportPage = lazy(
  () => import("@/features/student-view/passport/pages/student-passport")
);

const DiplomaPreviewPage = lazy(
  () => import("@/features/student-view/passport/pages/preview-diploma")
);

export const passportRoutes: RouteObject[] = [
  {
    path: "/admin/view-student-passport/:testId",
    element: <PassportPage isAdmin />,
  },
  {
    path: "/admin/diploma/preview",
    element: <DiplomaPreviewPage />,
  },
];
